import lodash from "lodash";
import moment from "moment";
import numeral from "numeral";
//redux

export const getData = (cashUp, branchs) => {
  // -------------------------- VAR --------------------------
  let data = [];

  cashUp?.forEach((item) => {
    const id = item?.id;
    const branch = item?.name;
    const branchId = item?.branch;
    const exist = branchs?.find((b) => b?.id === item?.branch);

    const shopId = exist?.shopId;
    const date = moment(item?.date, "DD/MM/YYYY");
    const totalIncome = item?.totalIncomeStaff || 0;
    const totalReceivable = item?.totalIncomeReceive || 0;
    const status = item.status;
    const difference = totalIncome - totalReceivable;
    const dataRow = {
      id,
      branch,
      shopId,
      date,
      totalIncome,
      totalReceivable,
      status,
      difference,
      branchId,
    };
    data.push(dataRow);
  });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return data;
};
